import auth from './auth';
import team from './team';
import technician from './technician';
import admin from './admin';
import area from './area';

export default [auth, team, technician, admin, area];
